import { ConvertToJSONService } from './convert-to-json.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { EncrdecrService } from './../Auth/encrdecr.service';
const headers = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }

@Injectable({
  providedIn: 'root'
})
export class PoaEdisService {
  ServerUrl = environment.ServerUrl;
  CompanyName = environment.CompayName;
  constructor(private http: HttpClient,
    private EncrdecrService: EncrdecrService,
    private ConvertToJSON: ConvertToJSONService) { }

    getPOAEDIS(formData)
    {
      console.log("Form Data",formData);
      let DataUrl = `${this.ServerUrl}/api/POAEDIS/SingleSource`;
      const req = {
        data: this.EncrdecrService.setEncr(formData)
      }
      console.log("Form Data Encrypted",req);
      return this.http.post<any>(DataUrl, req, headers);
    }
    getVerifyDISData(formData)
    {
      console.log("Data",formData);
      let DataUrl = `${this.ServerUrl}/api/POAEDIS/VerifyDIS`;
      const req = {
        data: this.EncrdecrService.setEncr(formData)
      }
      return this.http.post<any>(DataUrl, req, headers);
    }
    updatePOAEDIS(formData)
    {
      console.log("Data",formData);
      let DataUrl = `${this.ServerUrl}/api/POAEDIS/UpdatePOAEDIS`;
      const req = {
        data:formData,
      }
      return this.http.post<any>(DataUrl, req, headers);
    }
    getDematFlag(formData,rid,jid,userType,initiatedBy):Observable<any>
    {
      console.log("Data",formData);
      let DataUrl = `${this.ServerUrl}/api/POAEDIS/GetDematFlag`;
      const req = {
        data: this.EncrdecrService.setEncr(formData),
         //For thirdParty Journey Logs
         rid: rid,
         jid: jid,
         userType: userType,// User type
         initiatedBy: initiatedBy, // UserId
         //For thirdParty Journey Logs
      }
      return this.http.post<any>(DataUrl, req, headers);
    }
    deleteTransdetails(formData):Observable<any>
    {
      console.log("Data",formData);
      let DataUrl = `${this.ServerUrl}/api/POAEDIS/DeleteRecords`;
      const req = {
        data: this.EncrdecrService.setEncr(formData),
         
      }
      return this.http.post<any>(DataUrl, req, headers);
    }
}
